import React from "react"
import styled from "styled-components"
import { FastField } from "formik"

const StyledMobileNumberField = styled.div`
  > div {
    width: 100%;
    display: flex;
  }

  > div input:first-child {
    width: 75px;
    margin-right: 10px;
  }
`

function MobileNumberField({
  groupName,
  countryCodeName,
  mobileNumberName,
  touched,
  errors,
  values,
  disabled,
  mobileNumberValidate,
  countryCodeValidate
}) {
  let status = "default"
  const groupNameHasErrors =
    touched[groupName] && typeof errors[groupName] === "string"
  const countryCodeTouched =
    touched[groupName] && touched[groupName][countryCodeName]
  const countryCodeErrors =
    errors[groupName] && errors[groupName][countryCodeName]
  const mobileNumberTouched =
    touched[groupName] && touched[groupName][mobileNumberName]
  const mobileNumberErrors =
    errors[groupName] && errors[groupName][mobileNumberName]
  if (
    (countryCodeTouched && countryCodeErrors) ||
    (mobileNumberTouched && mobileNumberErrors) ||
    groupNameHasErrors
  ) {
    status = "has-error"
  } else if (
    (countryCodeTouched &&
      values[groupName][countryCodeName] &&
      !countryCodeErrors) ||
    (mobileNumberTouched &&
      values[groupName][mobileNumberName] &&
      !mobileNumberErrors)
  ) {
    status = "is-fixed"
  }
  return (
    <StyledMobileNumberField className={`MobileNumberField ${status}`}>
      <div>
        <FastField
          type="text"
          name={`${groupName}.${countryCodeName}`}
          placeholder="+63"
          disabled={disabled}
          validate={countryCodeValidate}
        />
        <FastField
          type="text"
          name={`${groupName}.${mobileNumberName}`}
          placeholder="91000100"
          disabled={disabled}
          validate={mobileNumberValidate}
        />
      </div>
      {(countryCodeTouched &&
        countryCodeErrors && (
          <div className="error-message">
            {errors[groupName][countryCodeName]}
          </div>
        )) ||
        (mobileNumberTouched &&
          mobileNumberErrors && (
            <div className="error-message">
              {errors[groupName][mobileNumberName]}
            </div>
          )) ||
        ((countryCodeTouched || mobileNumberTouched) &&
          groupNameHasErrors && (
            <div className="error-message">{errors[groupName]}</div>
          ))}
    </StyledMobileNumberField>
  )
}

export default MobileNumberField
